import { OcmConnection, OcmPoi, OcmStatusType } from '../../../../stores/types/ocm.interface';
import { ChargerLevel, FinderStatus } from '../types';

// OCM StatusType IDs that need more than IsOperational to interpret
const OCM_STATUS = {
  AVAILABLE: 10,
  IN_USE: 20,
  TEMPORARILY_UNAVAILABLE: 30,
  PARTLY_OPERATIONAL: 75,
};

// OCM UsageType 6: "Private - For Staff, Visitors or Customers"
const CUSTOMER_ONLY_USAGE_TYPE_ID = 6;
const CUSTOMER_ONLY_TITLE = /customer/i;

// OCM CurrentType 30 is DC
const OCM_CURRENT_TYPE_DC = 30;
const LEVEL_3_MIN_KW = 40;
const LEVEL_2_MIN_KW = 2;

const ONLINE_STATUSES = new Set([
  FinderStatus.AVAILABLE,
  FinderStatus.IN_USE,
  FinderStatus.OPERATIONAL,
  FinderStatus.PARTLY_OPERATIONAL,
]);

const OFFLINE_STATUSES = new Set([FinderStatus.OFFLINE, FinderStatus.TEMPORARILY_UNAVAILABLE]);

export const getLevelFromPowerKw = (powerKw?: number | null): ChargerLevel | undefined => {
  if (!powerKw || powerKw <= 0) return undefined;
  if (powerKw >= LEVEL_3_MIN_KW) return ChargerLevel.LEVEL_3;
  if (powerKw > LEVEL_2_MIN_KW) return ChargerLevel.LEVEL_2;
  return ChargerLevel.LEVEL_1;
};

export const getConnectionLevel = (connection: OcmConnection): ChargerLevel | undefined => {
  if (connection.LevelID) return connection.LevelID as ChargerLevel;
  if (connection.CurrentTypeID === OCM_CURRENT_TYPE_DC) return ChargerLevel.LEVEL_3;
  return getLevelFromPowerKw(connection.PowerKW);
};

export const isDcConnection = (connection: OcmConnection) =>
  connection.CurrentTypeID === OCM_CURRENT_TYPE_DC ||
  (connection.CurrentType?.Title ?? '').includes('DC');

export const getFinderStatus = (statusType?: OcmStatusType | null): FinderStatus => {
  if (!statusType) return FinderStatus.UNKNOWN;
  switch (statusType.ID) {
    case OCM_STATUS.AVAILABLE:
      return FinderStatus.AVAILABLE;
    case OCM_STATUS.IN_USE:
      return FinderStatus.IN_USE;
    case OCM_STATUS.TEMPORARILY_UNAVAILABLE:
      return FinderStatus.TEMPORARILY_UNAVAILABLE;
    case OCM_STATUS.PARTLY_OPERATIONAL:
      return FinderStatus.PARTLY_OPERATIONAL;
    default:
      break;
  }
  if (statusType.IsOperational === true) return FinderStatus.OPERATIONAL;
  if (statusType.IsOperational === false) return FinderStatus.OFFLINE;
  return FinderStatus.UNKNOWN;
};

export const isOnlineStatus = (status: FinderStatus) => ONLINE_STATUSES.has(status);

export const isOfflineStatus = (status: FinderStatus) => OFFLINE_STATUSES.has(status);

export const isCustomerOnly = (poi: OcmPoi) =>
  poi.UsageTypeID === CUSTOMER_ONLY_USAGE_TYPE_ID ||
  poi.UsageType?.ID === CUSTOMER_ONLY_USAGE_TYPE_ID ||
  CUSTOMER_ONLY_TITLE.test(poi.UsageType?.Title ?? '');
